import { JsonProvider } from 'leaflet-geosearch'

class CoordinatesProvider extends JsonProvider {
  search({ query, type }) {
    const data = this.parse(query)

    if (data) {
      return [{
        x: Number.parseFloat(data[1]),
        y: Number.parseFloat(data[0]),
        label: `${data[0]}, ${data[1]}`,
        visibleLabel: `Lat: ${data[0]} - Lng: ${data[1]}`,
        bounds: data
      }]
    } else {
      return []
    }
  }

  parse(query) {
    let data = query.split(',')

    if (!Array.isArray(data) || data.length !== 2) {
      data = query.split('\t')
    }
    if (!Array.isArray(data) || data.length !== 2) {
      data = query.split(';')
    }
    if (!Array.isArray(data) || data.length !== 2) {
      data = query.split('|')
    }
    if (data.length === 2) {
      return [Number.parseFloat(data[0].replaceAll(',', '.').trim()), Number.parseFloat(data[1].replaceAll(',', '.').trim())]
    } else return false
  }
}

export default CoordinatesProvider
